import { useContext, useState } from "react";
import { Store } from "../Store";

export const useOnModalError = () => {
  const { setShowModalError} = useContext(Store);
  const setModalErrorData = (errorData: any) => {
    let errorMessage: string = "";    
    if (!errorData.response.data) {
      console.log("status OK");
      errorMessage =  errorData.message;
    }
    if (errorData.response.status  >= 400 && errorData.response.status < 500 ) {  
      errorMessage = errorData.response?.data;
    }
    if (errorData.response.status  >= 500) {
      if(!errorData.response?.data.Success){
        errorMessage = errorData.response?.data.Message;
      }else{
        errorMessage = errorData.message;
      }
    }  
    if (errorMessage) {      
      setShowModalError?.({
          isError: true,
          title: errorMessage,
          ErrorType: "danger",
        });
    }
  };
  return setModalErrorData;
};
